/* eslint-disable no-unused-vars */
export enum ExpressionType {
  UIState = 'UIState',
  BindingData = 'BindingData',
  Unknow = 'UnKnow'
}

export interface IFilterDependency {
  type: ExpressionType;
  frameId: string;
  paths: string[]
}
